import useSectionBreakpointStyles from 'EmailEditorUI/hooks/styleSettings/useSectionBreakpointStyles';
const useSectionBackgroundCss = ({
  isDragging,
  section,
  selectable
}) => {
  const {
    backgroundColor,
    backgroundImage,
    backgroundImageType
  } = useSectionBreakpointStyles(section);
  const styles = {
    opacity: isDragging ? 0.4 : 1
  };
  if (!selectable || !section) {
    return styles;
  }
  styles.backgroundColor = backgroundColor || '';
  if (backgroundImage) {
    styles.backgroundPosition = 'center';
    styles.backgroundRepeat = backgroundImageType === 'REPEAT' ? 'repeat' : 'no-repeat';
    styles.backgroundImage = `url('${backgroundImage}')`;
    if (backgroundImageType === 'STRETCH') {
      styles.backgroundSize = '100% 100%';
    }
  }
  return styles;
};
export default useSectionBackgroundCss;